import { useState } from "react";
import { Button } from "@allaria-tech/matter/Button";
import { TextField } from "@allaria-tech/matter/TextField";
import styles from "./UploadDniCard.module.scss";

interface UploadErrorCopyLinkProps {
  isMobile: boolean;
  dniLink: string;
  onCopyLink: () => void;
  fileDropError: boolean;
  showDesktopInputCopy?: boolean;
  testId?: string;
}

const UploadErrorCopyLink = ({
  isMobile,
  dniLink,
  fileDropError,
  onCopyLink,
  showDesktopInputCopy,
  testId = "upload-error-copy-link",
}: UploadErrorCopyLinkProps) => {
  const { copyLinkContainer, uploadFromDesktopLink } = styles;

  const [showCopySection, setShowCopySection] = useState<boolean>(false);

  const isCopySectionVisible = showCopySection || showDesktopInputCopy;

  const showDesktopLink = fileDropError && !isMobile && !isCopySectionVisible;
  const showInputCopy = isCopySectionVisible || (fileDropError && isMobile);

  const handleShowInputLink = () => {
    setShowCopySection(true);
  };

  return (
    <>
      {showDesktopLink && (
        <div
          className={uploadFromDesktopLink}
          data-testid={`${testId}-desktop`}
        >
          <Button
            variant="tertiary"
            onClick={handleShowInputLink}
            text="Cargar archivos desde ordenador"
            testId={`${testId}-desktop-button`}
          />
        </div>
      )}
      {showInputCopy && (
        <div className={copyLinkContainer} data-testid={`${testId}-input`}>
          <hr />
          <h4>
            Ingresá en el siguiente link desde un ordenador para continuar con
            la carga de archivo.
          </h4>
          <TextField
            variant="url"
            value={dniLink}
            onClick={onCopyLink}
            testId={`${testId}-link`}
          />
        </div>
      )}
    </>
  );
};

export default UploadErrorCopyLink;
